import { useState, createContext } from 'react';
import { projectsData } from '../data/projects';

const ProjectsContext = createContext();

export const SingleProjectProvider = ({ children }) => {
  const [projects, setProjects] = useState(projectsData); // Correct usage of useState

  console.log('All Projects:', projects); // Debugging: Log all projects

  // Function to get a single project by ID
  const getProjectById = (id) => {
    console.log('Fetching project for ID:', id); // Debugging: Log the ID being searched
    const project = projects.find((project) => project.id === Number(id));
    console.log('Found Project:', project); // Debugging: Log the found project
    return project;
  };

  return (
    <ProjectsContext.Provider value={{ projects, getProjectById }}>
      {children}
    </ProjectsContext.Provider>
  );
};

export default ProjectsContext;
